export default __webpack_public_path__ + "static/media/MLRIT logo.7e6b6fc9.png";